import { ApiProperty } from "@nestjs/swagger";

export class RackSuggestionRequestDto {
    @ApiProperty()
    storeConsumptionId: number[];
    @ApiProperty()
    reportingCases?:number;
}
